export default {
  set_share_info({commit, state}, shareInfo) {
    const {cb} = shareInfo
    let fn = () => {
      let timer = setTimeout(() => {
        clearTimeout(timer)
        if(state.wxConfigSuccess && state.wechatUser.username) {
          commit('SET_WECHAT_SHARE_INFO', shareInfo)
          return cb()
        }
        fn();
      }, 500)
    }
    fn()
  }
}